import React, { useState } from "react";
import { solicitarResetPassword } from "../services/auth";
import "./Login.css"; // reutilizas estilos del login si quieres

const RecuperarPassword = () => {
  const [email, setEmail] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje("");
    setError("");

    try {
      await solicitarResetPassword(email);
      setMensaje("Hemos enviado un enlace de recuperación a tu correo.");
      setEmail("");
    } catch (err) {
      console.error("Error enviando solicitud:", err);
      setError("Hubo un problema al enviar el correo. Verifica que el correo esté registrado.");
    }
  };

  return (
    <div className="auth-container">
      <h2>Recuperar Contraseña</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Correo Electrónico</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        {mensaje && <p className="success-message">{mensaje}</p>}
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="auth-button">
          Enviar Instrucciones
        </button>
      </form>
    </div>
  );
};

export default RecuperarPassword;
